module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("eqZfY"))).then(() => parcelRequire('hIg1y'));